<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        dark
        v-on="on"
      >
        Add Grade
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Grade"
      text="Create Grade"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="form.rank_id"
                v-validate="'required'"
                :error-messages="errors.collect('rank_id')"
                :loading="loading"
                :items="validRanks"
                data-vv-name="rank_id"
                data-vv-as="rank"
                item-text="title"
                item-value="id"
                label="Rank"
              >
                <template v-slot:selection="data">
                  <v-chip :input-value="data.selected">
                    <v-avatar tile>
                      <img :src="data.item.image_url">
                    </v-avatar>
                    {{ data.item.title }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-avatar 
                      size="40px" 
                      tile
                    >
                      <img :src="data.item.image_url">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.title" />
                      <v-list-item-subtitle> {{ `Rank ${data.item.value}` }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="form.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.description"
                v-validate="'max:500'"
                :error-messages="errors.collect('description')"
                :rows="3"
                data-vv-name="description"                
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      category: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,
        categoryRanks: [],
        form: {
          rank_id: null,
          name: '',
          description: '',
        },
        ranks: [],      
      }
    },
    computed: {
      validRanks () {
        return this.ranks.filter(rank => {
          return this.categoryRanks.find(categoryRank => categoryRank.id === rank.id) === undefined
        })
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()
          this.loadData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.progressing = true

          this.$api.grades().create(this.category.id, this.prepareFormData())
            .then(response => {
              this.$emit('created')
              this.$snack({ message: response.data.status })

              this.dialog = false
            })
            .catch(() => {})
            .then(() => {
              this.progressing = false
            })
        })
      },
      loadData () {
        this.loading = true 

        Promise.all([
          this.$api.ranks().list(),
          this.$api.grades().list(this.category.id),
        ])      
          .then(([ranks, categoryRanks]) => {
            this.ranks = ranks.data
            this.categoryRanks = categoryRanks.data
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      resetForm () {
        this.form = {
          rank_id: null,
          name: '',
          description: '',
        }

        this.$validator.reset()
      },
      prepareFormData () {
        if (this.form.description) return this.form

        let formCopy = { ...this.form }
        delete formCopy.description

        return formCopy
      },
    },
  }
</script>
